import { KoDate, KoForm, KoFormBuilder,  KoSelect, KoTextArea, KoUserSelect } from 'packages';
import React, { useCallback, useEffect } from 'react';
import styles from './leave.module.scss';
import { useSelector } from 'react-redux';
import LeaveTableList from './leaveDates';

export default function LeaveCurd({form, leaveTypes, handleFinish, initialValues}) {
  const users = useSelector(state => state?.users);
  const holidays = useSelector(state => state?.holidays);
  const start = KoForm.useWatch('start', form);
  const end = KoForm.useWatch('end', form);

  useEffect(() => {
   
    if (!initialValues || Object.keys(initialValues).length === 0) {
      form.resetFields();
    } else {
      form.setFieldsValue(initialValues);
    }
  }, [initialValues, form]);
        

  const handleSubmit = useCallback(values => {
    let fullDays = 0;
    let firstHalfDays = 0;
    let secondHalfDays = 0;
    values?.leaveDates?.forEach(item => {
      if (item.leaveDuration === 1) {
        fullDays++;
      } else if (item.leaveDuration === 2) {
        firstHalfDays++;
      } else if (item.leaveDuration === 3) {
        secondHalfDays++;
      }
    });
    const totalLeaveDays = fullDays + (firstHalfDays / 2) + (secondHalfDays / 2);
    values['totaldays'] = totalLeaveDays;
    handleFinish(values);
  });
 

  const Managers = ({ value, onChange }) =>
    <KoUserSelect value={value} onChange={v => onChange(v)} mode="multiple" users={users['data']} placeholder='Select Team Members' />;
  
  const ManagersA = ({ value, onChange }) =>
    <KoUserSelect value={value} onChange={v => onChange(v)} users={users['data']} placeholder='Select Team Members' />;
  
  const LeaveTable = ({ value, onChange }) =>
    <LeaveTableList form={form} datax={value} profile={users['data']} handleFinish={handleSubmit}/>;
  
    
  const LeaveType = ({ value, onChange }) =>
    <KoSelect
      placeholder="Select Leave Type"
      value={value}
      onChange={v => onChange(v)}
      options={leaveTypes?.map((modulex) => ({
        label: modulex?.name,
        value: modulex?.leaveTypeId
      }))}
    />;

  const Date = ({ value, onChange }) =>
    <KoDate value={value} format = {'DD-MMM-YYYY'}
      holidays={holidays['data']}
      onChange={v => onChange(v)} />;
    
  const meta = {
    columns: 6,
    formItemLayout: null,
    initialValues,
    colon: true,
    fields: [
     
      {
        key: 'start', label: 'Start Date', colSpan: 2,
        widget: Date, rules: [
          {
            required: true,
            message: `Please enter date.`
          }
        ]
      },
      {
        key: 'end', label: 'End Date', colSpan: 2,
        widget: Date, rules: [
          {
            required: true,
            message: `Please enter date.`
          }
        ]
      },
      {
        key: 'leaveType', label: 'Leave Type', colSpan: 2,
        widget: LeaveType, rules: [
          {
            required: true,
            message: `Please enter date.`
          }
        ]
      },
      {
        key: 'approver', label: 'Approver', colSpan: 2,
        widget: ManagersA,
        rules: [
          {
            required: true,
            message: `Please select approver.`
          }
        ]
      },
      {
        key: 'notify', label: 'Notify', colSpan: 4,
        widget: Managers
      },
      {
        key: 'reason', widget: KoTextArea, label: 'Note / Reason', colSpan: 6, placeholder: 'Enter note / reason',
        rules: [
          {
            required: true,
            message: `Please enter note / reason.`
          }
        ]
      }
     
    ]
  };

  if (start && end) {
    meta['fields'].push( {
      key: 'leaveDates', label: '', colSpan: 6,
      widget: LeaveTable
    });
  }

  return (
    <div className={styles.wrapperCurd}>
      <KoForm form={form} layout="vertical" onFinish={handleSubmit} onSubmit={handleSubmit} >
        <KoFormBuilder form={form} meta={meta} />
      </KoForm>
    </div>
  );
}
